import { apiUrl } from '../config/api'
import '../config/httpInterceptor'

export async function getCaptainOrder(orderId) {
  const resp = await fetch(apiUrl(`/api/captain/orders/${orderId}`))
  if (resp.status === 401) return { status: 401 }
  if (resp.status === 403) return { status: 403 }
  if (resp.status === 404) return { status: 404 }
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
  const body = await resp.json()
  return { status: 200, body }
}

export async function claimOrder(orderId) {
  const resp = await fetch(apiUrl(`/api/captain/orders/${orderId}/claim`), { method: 'POST' })
  if (resp.status === 409) return { status: 409 }
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
  const body = await resp.json()
  return { status: 200, body }
}

export async function getMyDashboard() {
  const resp = await fetch(apiUrl(`/api/captain/dashboard`))
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
  return resp.json()
}
